// Mappa sezione → video tutorial dedicato (registrazioni schermo reali, voce narrante).
// IT: interfaccia e voce in italiano · EN: interfaccia e voce in inglese; altre lingue → fallback IT.
const H = (s) => ({ it: `/videos/help/${s}_it.mp4`, en: `/videos/help/${s}_en.mp4`, es: `/videos/help/${s}_es.mp4`, fr: `/videos/help/${s}_fr.mp4`, de: `/videos/help/${s}_de.mp4` });

export const SECTION_VIDEOS = {
  dashboard: H("dashboard"),
  cassa: H("cassa"),
  reservations: H("reservations"),
  production: H("production"),
  partners: H("partners"),
  orders: H("orders"),
  recipes: H("recipes"),
  preparations: H("preparations"),
  inventory: H("inventory"),
  inglist: H("inglist"),
  catalog: H("catalog"),
  reorder: H("reorder"),
  shifts: H("shifts"),
  azienda: H("azienda"),
  attendance: H("attendance"),
  invoices: H("invoices"),
  staff: H("staff"),
  waste: H("waste"),
  documents: H("documents"),
  payments: H("payments"),
  stats: H("stats"),
  reports: H("reports"),
  billing: H("billing"),
  formula: H("formula"),
  trash: H("trash"),
  permessi: H("permessi"),
};

export const ROUTE_SECTIONS = {
  "/app": "dashboard",
  "/app/cassa": "cassa",
  "/app/prenotazioni": "reservations",
  "/app/production": "production",
  "/app/partners": "partners",
  "/app/suppliers": "partners",
  "/app/orders": "orders",
  "/app/recipes": "recipes",
  "/app/formula": "formula",
  "/app/lab": "preparations",
  "/app/inventory": "inventory",
  "/app/ingredients-list": "inglist",
  "/app/catalog": "catalog",
  "/app/reorder": "reorder",
  "/app/shifts": "shifts",
  "/app/azienda": "azienda",
  "/app/attendance": "attendance",
  "/app/invoices": "invoices",
  "/app/staff": "staff",
  "/app/waste": "waste",
  "/app/documents": "documents",
  "/app/payments": "payments",
  "/app/stats": "stats",
  "/app/reports": "reports",
  "/app/billing": "billing",
  "/app/trash": "trash",
};

export const sectionForPath = (pathname) => ROUTE_SECTIONS[pathname.replace(/\/+$/, "")] || null;
